import GitReferencesSelector from './GitReferencesSelector';

export type {GitReference, GitReferenceType} from './GitReferencesSelector';

export default GitReferencesSelector;
